import React from 'react';
import { Text, View } from 'react-native';
import { posSharedUi as posUi } from '../../shared/ui/posSharedUi';
import { sourceLabels } from '../screens/catalogScreen.constants';
import { catalogProductFormStyles as styles } from './catalogProductForm.styles';
import type { CatalogProductFormFieldsProps } from './catalogProductFormFields.types';

type Props = Pick<CatalogProductFormFieldsProps, 'formSuggestion'>;

export function CatalogProductFormSuggestion({ formSuggestion }: Props) {
  if (!formSuggestion) return null;

  return (
    <View style={[posUi.paymentCard, styles.suggestionBlock]} testID="catalog.form.suggestion">
      <View style={styles.lookupHeader}>
        <Text style={styles.blockTitle}>Datos encontrados</Text>
        <Text style={styles.lookupBadge}>{sourceLabels[formSuggestion.source]}</Text>
      </View>
      <Text style={styles.lookupName}>{formSuggestion.suggestion.name}</Text>
      <Text style={posUi.checkoutHint}>
        {formSuggestion.suggestion.brand
          ? `Marca: ${formSuggestion.suggestion.brand}`
          : 'No encontramos la marca.'}
      </Text>
      <Text style={posUi.checkoutHint}>
        {formSuggestion.requiresReview
          ? 'Revisá el nombre y la marca antes de guardar.'
          : 'Datos asociados a este código.'}
      </Text>
    </View>
  );
}
